import { getOrdersIdAttachments } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const ORDER_ATTACHMENTS = "ORDER_ATTACHMENTS";

export const getOrderAttachmentsQueryKey = (orderId: number) => [
	ORDER_ATTACHMENTS,
	orderId,
];

export function useOrderAttachmentsQuery(orderId: number) {
	return useQuery({
		queryKey: getOrderAttachmentsQueryKey(orderId),
		queryFn: processResponse(() => getOrdersIdAttachments(orderId)),
		retry: false,
		// Signed URLs expire after one hour — refetch well before that.
		refetchInterval: 30 * 60 * 1000,
		refetchIntervalInBackground: false,
		refetchOnWindowFocus: true,
		enabled: !!orderId,
	});
}
